<template>
    <div>
        <ion-grid>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="search-view">
                <ion-col >
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3">
                            <ion-label>Enter Email ID</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input id="emailOrMobile" v-model="emailOrMobile" class="form-input" type="text"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>User Role</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select 
                                    v-model="roleId"
                                    class="form-select select-mobile"
                                    placeholder="Select Status"
                                    interface="action-sheet">
                                    <ion-select-option
                                        v-for="role in userRoleOptions"
                                        :key="role.roleId"
                                        :value="role.roleId"
                                    >
                                        {{ role.description }}
                                    </ion-select-option>
                                </ion-select>
                                <select
                                    class="input-select select-web"
                                    v-model="roleId"
                                    placeholder="Select Status"
                                    >
                                    <option
                                        v-for="role in userRoleOptions"
                                        :key="role.roleId"
                                        :value="role.roleId"
                                        >
                                        {{ role.description }}
                                    </option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <br />
                            <ion-button class="btn-search margin-top-10" @click="searchUser">Search</ion-button>
                            <ion-button class="btn-clear margin-top-10"  @click="clearFields">
                                <ion-icon :icon="refresh"></ion-icon>
                            </ion-button>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="list-view">
                <ion-col>
                    <ion-row class="list-head">
                        <ion-col size="12" size-md="2">
                            <ion-label>User Name</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Email ID</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>User Role</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Effective From</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Effective To</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1">
                            <ion-label>Delete User</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item" v-for="(value, index) in usersDetails" :key="value">
                        <ion-col size="12" size-md="2" >
                            <ion-label class="text-link">{{ value.userName }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2" style="cursor: pointer;" @click="addUserEmailInFilter(value.emailOrMobile)">
                            <ion-label>{{ value.emailOrMobile }}</ion-label></ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>{{ value.description }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>{{ changeDateFormatWithoutTime(value.effectiveFrom) }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>{{ changeDateFormatWithoutTime(value.effectiveTo) }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1" class="icon-col">
                             <ion-icon :icon="trashOutline" class="delete-icon" @click="deleteUser(value, index)" />
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
             <ion-row v-if="norecordsfound">
                <ion-col size="12" class="pagination-info">
                <ion-label class="pagination-info">No records found for the selected filters</ion-label>
                </ion-col>
            </ion-row>
            <ion-row v-else>
                <ion-col size="12" size-md="5">
                <ion-label
                    class="pagination-info"
                >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                </ion-col>
                <ion-col size="12" size-md="7" class="ion-text-right">
                <div class="pagination">
                    <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                    <a class="prev disabled" v-else>Prev</a>
                    <a
                    
                    v-for="page in this.pagesList"
                    :key="page"
                    v-bind:class="{'active': pageNo == page}"
                    @click="loadPage(page)"
                    >{{page}}</a>
                    <a
                    
                    class="next"
                    v-if="this.pageNo < this.totalPages"
                    @click="loadPage(pageNo + 1)"
                    >Next</a>
                    <a class="next disabled" v-else>Next</a>
                </div>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonButton, IonCol, IonGrid, IonLabel, IonRow, IonInput, IonSelect, IonSelectOption, IonIcon, alertController} from "@ionic/vue";
import { refresh, trashOutline } from 'ionicons/icons';
import { migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";
import { AdminService } from "@/service/admin/admin.service";
import { updateUserFromAdmin } from "../../entity/authentication/profile";
import moment from "moment";


export default defineComponent({
    name: 'CPOUserCreation',
    components:{
        IonGrid, IonRow, IonCol, IonButton, IonLabel,IonInput, IonSelect, IonSelectOption, IonIcon, alertController
    },
    data(){
        return{
            refresh,
            trashOutline,
            userRoleOptions: '',
            emailOrMobile: '',
            effectiveFrom: '',
            effectiveTo: '',
            status: '',
            userName: "",
            roleId: '',
            totalRecords: 0,
            pageRecords: 10,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            usersDetails: [],
            norecordsfound: true,
            filteredData: ""
        }
    },
    async mounted() {
        this.userRoleOptions = await new AdminService().userRoles("List");

        var page = localStorage.getItem('userPage');
        if (page) {
        this.pageNo = Number(page);
        }
        var search = localStorage.getItem('userSearch');
        if (search) {
            search = JSON.parse(search);
            this.emailOrMobile = search.emailOrMobile;
            this.roleId = search.roleId;
            this.searchUser();
        } else {
            this.searchUser()
        }
    },

    methods: {
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },
        addUserEmailInFilter(emailOrMobile) {
            document.getElementById('emailOrMobile').value = emailOrMobile;
            this.emailOrMobile = emailOrMobile;
        },

        viewUserDetails(value, index) {
            localStorage.setItem("selectedUserDetail", JSON.stringify(value));
            localStorage.setItem("editUserIndex", index); 
            this.$router.push("userDetails");
        },

        async deleteUser(value, index) {
             const alert = await alertController.create({
                header: "Confirm",
                message: "Are you sure want to delete?",
                buttons: [
                    {
                        text: "NO",
                        role: "cancel",
                        cssClass: "secondary",
                        handler: () => {
                            console.log('cancel')
                        }
                    },
                    {
                        text: "YES",
                        handler: () => {
                            this.deleteUserDetails(value, index);
                        }
                    }
                ]
            });
            await alert.present();
        },

        async deleteUserDetails(value, index) {
            try {
                let result = await new AdminService().deleteUser(value.userId);

                if(result.data.success){
                    new ToastUtils().presentToast(result.data.message);
                    this.usersDetails.splice(index, 1);
                    this.totalRecords--;
                }
            } catch(error){
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);

            }
        },

        async searchUser() {
            let existingFilterData = JSON.parse(localStorage.getItem("userSearch"))
            let searchFilterData = {
                    emailOrMobile: this.emailOrMobile,
                    roleId: this.roleId
                }
            if(!this.areFiltersEqual(searchFilterData, existingFilterData)) {
                localStorage.setItem("userSearch",JSON.stringify(searchFilterData));
                this.pageNo = 1;
                localStorage.setItem('userPage', this.pageNo);
            } else {
                let pageNo = localStorage.getItem('userPage');
                if(pageNo) {
                    this.pageNo = pageNo;
                } else {
                    this.pageNo = 1;
                }
            }
            try {
                let result = await new AdminService().userNameList(
                    this.pageNo,
                    this.pageRecords,
                    {
                        emailOrMobile: this.emailOrMobile,
                        roleId: this.roleId,
                        effectiveFrom: this.effectiveFrom,
                        effectiveTo: this.effectiveTo,
                        userName: this.userName,
                        status: this.status,
                    }
                );

                this.filteredData = result.data.filter(user => {
                    const matchesEmailOrMobile = this.emailOrMobile
                        ? user.emailOrMobile.toLowerCase().includes(this.emailOrMobile.toLowerCase())
                        : true;
                    const matchesRole = this.roleId ? user.roleId == this.roleId : true;

                    return matchesEmailOrMobile && matchesRole;
                });

                this.totalRecords = this.filteredData.length;

                this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                this.pageNo
                );

                this.totalPages = new PaginationUtils().getTotalPages(
                this.totalRecords,
                this.pageRecords
                );

                const pageData = { recordNumber: 0, records: 9999999999 };

                try {
                pageData.records = parseInt(this.pageRecords);
                pageData.recordNumber = parseInt(
                    pageData.records * (this.pageNo - 1)
                );

                this.usersDetails = this.filteredData.slice(
                    pageData.recordNumber,
                    pageData.records * this.pageNo
                );

                this.norecordsfound = false;
                } catch (error) {
                console.log("Pagination Error:", error);
                }
                
                if(result?.success) {
                    new ToastUtils().presentToast(result.message);
                }
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
            
            (this.totalPages = new PaginationUtils().getTotalPages(
                this.totalRecords,
                this.pageRecords
            ));
            
        },

        areFiltersEqual(a, b) {
            return JSON.stringify(a) === JSON.stringify(b);
        },

        async loadPage(page) {
            try {
                this.pageNo = page;
                this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                this.pageNo
                );
                localStorage.setItem("userPage", page);
                

                const pageData = { recordNumber: 0, records: 9999999999 };

                pageData.records = parseInt(this.pageRecords);
                pageData.recordNumber = parseInt(
                pageData.records * (this.pageNo - 1)
                );

                this.usersDetails = this.filteredData.slice(
                pageData.recordNumber,
                pageData.records * this.pageNo
                );
            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },

        clearFields() {
            this.emailOrMobile = "";
            this.roleId = "";
            this.pageNo = 1;
            this.searchUser();
        },
    }
})
</script>

<style scoped>
.text-link {
    font-family: "Roboto Medium";
    font-size: 13px;
    letter-spacing: 0;
    color: #21b24b;
    opacity: 1;
}
.icon-col {
  display: flex;
  justify-content: center;
  align-items: center;     
}
.delete-icon {
  color: red;        
  font-size: 14px; 
  cursor: pointer; 

}
.container-div{
    /* width: 30%; */
    margin-top: 20px;
    border: 2px solid rgb(240, 236, 236);
    border-radius: 20px;
    box-shadow: 2px 2px rgb(70, 68, 68);
    
}
.usage-txt{
    font-size: 22px;
    text-align: center;
}
.report-list{
    margin: 80px 0 0 0;
}
.edit-payment {
  font-size: 17px;
  /* margin-left: 2px; */
  cursor: pointer;
}
</style>